import { useCallback, useState } from 'react';
import { MediaLightbox } from './MediaLightbox';
import { MediaThumbnails } from './MediaThumbnails';
import { MediaItem } from './types';

export function MediaGallery({
  title,
  items,
  tone = 'light',
}: {
  title: string;
  items: MediaItem[];
  tone?: 'light' | 'dark';
}) {
  const [startIndex, setStartIndex] = useState(0);
  const [open, setOpen] = useState(false);

  const openTo = useCallback((index: number) => {
    setStartIndex(index);
    setOpen(true);
  }, []);

  if (!items.length) return null;

  return (
    <>
      <MediaThumbnails items={items} onSelect={openTo} tone={tone} />
      <MediaLightbox
        title={title}
        items={items}
        open={open}
        onOpenChange={setOpen}
        startIndex={startIndex}
      />
    </>
  );
}
